import { BaseEtlImport } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { loadEtlImports } from "../../../etlData/useCases/load-imports/loadEtlImports.use-case";
import { createEtlImport } from "core/src/slices/etlData/useCases/create-etl-import/createEtlImport.use-case";
import { apiSlice } from "core/src/store/rtk-instance";
import { patchEtlImport } from "core/src/slices/etlData/useCases/patch-etl-import/patchEtlImport.use-case";

type InitAppResponse = {
	selectedEtlImportUuid: string;
}

export const initApp = createAppAsyncThunk<InitAppResponse, void>(
	"initApp",
	async (_, { dispatch, getState, rejectWithValue }) => {
		try {
			const { user, isAuthenticated, username, password } = getState().auth;

			if (isAuthenticated && user) {
				const response = await dispatch(loadEtlImports());

				const { etlImports } = response.payload as { etlImports: BaseEtlImport[] };

				if (etlImports && etlImports.length > 0) {

					const selectedEtlImport = etlImports[0];
					dispatch(patchEtlImport({ uuid: selectedEtlImport.uuid, data: { username, password } }));
					dispatch(apiSlice.endpoints.getSelectedEtlImport.initiate({ uuid: selectedEtlImport.uuid }));

					return {
						selectedEtlImportUuid: selectedEtlImport.uuid,
					}
				}

				if (etlImports && etlImports.length === 0) {
					const createResponse = await dispatch(createEtlImport({
						company_id: user.company.id,
						label: user.company.label,
						user_id: user.id,
						hiboutik_subdomain: user.company.hiboutikAccount.subDomain,
						hiboutik_token: user.company.hiboutikAccount.token,
						meta_data: {
							laboratories: user.laboratories.map((laboratory) => ({
								...laboratory,
							})),
						},
						username,
						password,
					}));

					dispatch(loadEtlImports());
					const etlImport = createResponse.payload as BaseEtlImport;
					dispatch(apiSlice.endpoints.getSelectedEtlImport.initiate({ uuid: etlImport.uuid }));

					return {
						selectedEtlImportUuid: etlImport.uuid,
					}
				}
			}

			return {
				selectedEtlImportUuid: "",
			}
		} catch (e) {
			return rejectWithValue(e);
		}
	},
	{
		condition: (_, { getState }) => {
			const { isLoadingImports, appIsInitialized } = getState().etlData;
			if (isLoadingImports || appIsInitialized) return false;
		}
	}
);
